import { FC } from 'react';

import { H3, Separator } from '@smartshell/ui-kit';

import { ISummaryTooltipProps } from './interfaces';
import s from './ReportSummaryTooltip.module.scss';

export const ReportSummaryTooltip: FC<ISummaryTooltipProps> = ({
  title,
  text_1,
  text_2,
  footer,
  value_1,
  value_2,
  variant,
}) => {
  return (
    <div className={s.tooltip_content}>
      <H3 className={s.title}>{title}</H3>
      {variant === 'primary' && (
        <>
          <div className={s.info}>
            <div className={s.line}>
              <span className={s.text}>{text_1}</span>
              <span className={s.value}>{value_1}</span>
            </div>
            <div className={s.line}>
              <span className={s.text}>{text_2}</span>
              <span className={s.percent}>{value_2}</span>
            </div>
          </div>
          <Separator />
        </>
      )}
      <span className={s.footer}>{footer}</span>
    </div>
  );
};
